/* Small progressive enhancements. All catalog, links and forms remain server rendered. */
(() => {
  'use strict';
  if (window.__esStudioLoaded) return;
  window.__esStudioLoaded = true;
  const videos = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (!entry.isIntersecting && !entry.target.paused) entry.target.pause(); });
  }, { threshold: 0.05 }) : null;
  function initialize(root = document) {
    root.querySelectorAll('[data-es-video] video').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.addEventListener('play', () => {
        document.querySelectorAll('[data-es-video] video').forEach(other => {
          if (other !== video && !other.paused) other.pause();
        });
      });
      observer?.observe(video);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-es-video] video').forEach(video => {video.pause();observer?.unobserve(video);});
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-es-video] video').forEach(video => video.pause());
  });
})();
